
function getNavLinks() {
  const links = [
    { id: 'home',            label: 'Home',               icon: '⏰' },
    { id: 'most-liked',      label: 'Most Liked',         icon: '🏆' },
    { id: 'company-heatmap', label: 'Company Heat Map',   icon: '🔥' },
    { id: 'jobs',            label: 'Jobs',               icon: '💼' },
    { id: 'salaries',        label: 'Role Salary Guide',  icon: '📊' },
  ];
  return links;
}

export default function LeftDashboard({ view, setView, onHomeClick, onAddClick, isGuest }) {
  const NAV_LINKS = getNavLinks();

  return (
    <aside data-tour="nav" style={{ display: 'flex', flexDirection: 'column', gap: 12, position: 'sticky', top: 52, width: '100%', height: 'min-content', paddingTop: 24 }}>
      {/* Nav Links */}
      <div className="left-sidebar-nav" style={{ background: 'var(--surface2)', border: '1px solid var(--border)', borderRadius: 14, padding: '0 10px' }}>
        <div style={{ display: 'flex', flexDirection: 'column', gap: 0 }}>
          {NAV_LINKS.map((link, idx) => {
            const isActive = view === link.id || (link.id === 'home' && (view === 'home' || view === 'search' || view === 'highlight'));
            return (
              <div
                key={link.id}
                onClick={() => {
                  if (link.id === 'home' && onHomeClick) onHomeClick();
                  else setView(link.id);
                }}
                style={{
                  display: 'flex', alignItems: 'center', gap: 10, position: 'relative',
                  padding: '12px 10px',
                  borderBottom: idx < NAV_LINKS.length - 1 ? '1px solid var(--border)' : 'none',
                  color: isActive ? 'var(--blue)' : 'var(--text)',
                  fontWeight: isActive ? 700 : 600, fontSize: 13,
                  transition: 'all 0.15s cubic-bezier(0.4, 0, 0.2, 1)',
                  cursor: 'pointer', fontFamily: 'var(--sans)',
                  borderRadius: 8,
                  background: isActive ? 'var(--surface)' : 'transparent',
                  boxShadow: isActive ? '0 1px 3px rgba(0,0,0,0.06)' : 'none',
                  margin: '2px 0',
                }}
              >
                <span style={{ fontSize: 16 }}>{link.icon}</span>
                <span>{link.label}</span>
                {isActive && (
                  <div style={{
                    position: 'absolute', right: 10,
                    width: 6, height: 6, borderRadius: '50%', background: 'var(--blue)',
                  }} />
                )}
              </div>
            );
          })}
        </div>
      </div>
      {!isGuest && onAddClick && (
        <button
          onClick={onAddClick}
          style={{
            width: '100%', background: 'var(--blue)', color: '#fff',
            fontFamily: 'var(--sans)', fontSize: 14, fontWeight: 700,
            padding: '13px 0', borderRadius: 10, border: 'none',
            cursor: 'pointer', boxShadow: '0 4px 10px rgba(14,165,233,0.2)',
            marginTop: 20,
          }}
        >
          + Share My HireKahani
        </button>
      )}
    </aside>
  );
}
